import React from 'react';
import {
    Route,
    Switch,
    Redirect
} from 'react-router';

import { PrivateRoute } from '../components/PrivateRoute';

import Login from './Login';
import Register from './Register';
import Home from './Home';
import Analytics from './Analytics'
import ErrorPage from './ErrorPage';
import {MunicipalitySurvey} from './Surveys/MunicipalitySurvey';
import {ResidentSurvey} from './Surveys/ResidentSurvey';
import AnalyticsDashboardExport from '../components/AnalyticsDashboardExport';

//------ Route Definitions --------
// eslint-disable-next-line no-unused-vars
export const RoutedContent = (props) => {

    return (
      <Switch>
          {/* <Redirect from="/" to="/home" exact />*/}
          

          <Route
          path="/app/nationaldatabase"
          exact
          component={Analytics}
        />

      <Route
          path="/app/nationaldatabase/export"
          exact
          component={AnalyticsDashboardExport}
        />
  {/*
        <Route
          path="/app/"
          exact
          component={LandingPage}
        />
*/}
        <PrivateRoute
          path="/app/municipality"
          exact
          component={Home}
        />
        <PrivateRoute
          path="/app/entity"
          exact
          component={Home}
        />
        <Route
          path="/app/resident"
          exact
          component={Home}
        />
        <PrivateRoute
          path="/app/municipality/questionnaire"
          exact
          component={MunicipalitySurvey}
        />
        <Route
          path="/app/resident/questionnaire"
          exact
          component={ResidentSurvey}
        />
        <Route component={Login} path="/app/login" />
        <Route component={Register} path="/app/register" />
       
       
        <Route path="*" component={ErrorPage} /> 

        {/*    Pages Routes    */}
        

        {/*    404    
        <Redirect to="/error-404" />*/}
      </Switch>
    );
};


